export default __webpack_public_path__ + "static/media/attachment.2513f640.svg";